import { Component, EventEmitter, OnInit, Output, ViewChild } from "@angular/core";
import { AbstractControl, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Comarca } from "../../../model/comarca";
import { Lotacao } from "../../../model/lotacao";
import { ToastrService } from "ngx-toastr";
import { RelatorioRecadastramentoService } from "../../../service/relatorio-recadastramento/relatorio.service";
import { PosCampanhaService } from "../../../service/posCampanha/pos-campanha.service";
import { Observable } from "rxjs";
import { Page } from "../../../model/Paginacao/Page";
import { PeriodoData } from "../../../model/periodoData.dto";
import * as moment from "moment";
import { MatAutocompleteTrigger } from "@angular/material/autocomplete";
import { debounceTime } from "rxjs/operators";

@Component({
  selector: 'app-filtro',
  templateUrl: './filtro-pos-recad.component.html',
  styleUrls: ['./filtro-pos-recad.component.sass']
})
export class FiltroPosRecadComponent implements OnInit {
  form: FormGroup;
  anos: number[] = [];
  comarcas: Comarca[] = [];
  lotacoes: Lotacao[] = [];
  lotacao: number;
  lotacaoDigitado: string;
  options: any[] = [];
  optionsServidor: any[] = [];
  filteredOptions: any[] = [];
  filteredOptionsServidor: any[] = [];
  @ViewChild(MatAutocompleteTrigger) autoTrigger: MatAutocompleteTrigger;
  @Output() filtros: EventEmitter<any> = new EventEmitter<any>();
  matricula: number;

  constructor(private toastrService: ToastrService,
              private formBuilder: FormBuilder,
              private relatorioService: RelatorioRecadastramentoService,
              private posCampanhaService: PosCampanhaService) { }

  ngOnInit(): void {
    this.createForm();
    this.tipoCampanha();
    this.findComarcas();
    this.form.get('lotacao').disable();

    this.form.get('comarca').valueChanges.subscribe((comarca) => {

      if (comarca) {
        // Se a comarca estiver preenchida, habilite o campo de lotacao
        this.form.get('lotacao').enable();
        this.form.get('lotacao').setValue('');
      } else {
        // Se a comarca estiver vazia, desabilite o campo de lotacao
        this.form.get('lotacao').disable();
      }
    });
    this.initAutoComplete();
    this.initAutoCompleteServidor();
    /*this.form.controls['ano'].setValue('2023');
    this.periodoCampanha();*/
  }

  private initAutoComplete() {
    this.form.get("lotacao").valueChanges
      .pipe(
        debounceTime(400)
      )
      .subscribe((value) => {
        if (value && value.length >= 3) {
          this.findLotacao();
        }
      });
  }

  private initAutoCompleteServidor() {
      this.form.get("servidor").valueChanges
      .subscribe((servidor) => {
        if (servidor && servidor.length >= 3 && this.form.get("servidor") != servidor) {
          this.onInputChange();
        }
      });
  }

  createForm(){
    this.form = this.formBuilder.group({
      ano: ['', [Validators.required]],
      dataInicio: [''],
      dataFim: [''],
      comarca: [''],
      lotacao: [''],
      servidor: [''],
    });
    this.form.get('servidor')?.disable();
    this.form.get('lotacao')?.disable();
    this.lotacao = 0;
    this.matricula = 0;
  }

  tipoCampanha() {
    this.getAnosDisponiveisCampanha().subscribe(
      response => {
        this.anos = response;
      },
      (error) => {
        console.error(error);
      }
    );
  }

  findComarcas() {
    this.getComarcas().subscribe(
      response => {
        this.comarcas = response;
      },
      (error) => {
        console.error(error);
      }
    );
  }
  public onOptionSelected(option: any): void {
    this.form.get('lotacao').setValue(option.descricao);
    this.lotacao = option.id;
  }

  public onOptionSelectedServidor(option: any): void {
    this.form.get('servidor').setValue(option.nome);
    this.matricula = option.matricula;
  }

  // findLotacao() {
  //   this.getLotacao(this.form.value.comarca).subscribe(
  //     response => {
  //       console.log(response)
  //       this.lotacoes = response.content;
  //     },
  //     (error) => {
  //       console.error(error);
  //     }
  //   );
  // }

  public findLotacao(): void {
    const value = this.form.value.lotacao;

    if (value) {
      this.lotacaoDigitado = value ? value : 0;
      this.getLotacao(this.form.value.comarca, this.lotacaoDigitado ).subscribe(
        (response) => {
          this.options = response.content;


          this.filteredOptions = this.options.filter((option) =>
            option.descricao.toLowerCase().includes(value.toLowerCase())
          );

          this.autoTrigger.openPanel();
        },
        (error) => {
          console.error(error);
        }
      );

    } else {
      this.options = [];
      this.filteredOptions = [];
    }
  }

  checkDiffData() {
    if (this.form.value.dataFim < this.form.value.dataInicio && this.form.value.dataFim != '' && this.form.value.dataFim != null) {
      this.toastrService.warning("Data de inicio maior que data fim.")
      this.form.controls.dataFim.reset()
    }
  }

  private getAnosDisponiveisCampanha(): Observable<any> {
    return this.relatorioService.anosCampanha();
  }

  private getComarcas(): Observable<any> {
    return this.posCampanhaService.getComarca();
  }

  private getLotacao(idLotacao: number, valorLotacao): Observable<Page<Lotacao>> {
    return this.posCampanhaService.getLotacao(idLotacao, 0, valorLotacao);
  }

  limparFiltros() {
    this.createForm();
    this.initAutoComplete();
    this.initAutoCompleteServidor();
    this.filtros.emit(null);
  }


  filtarRecadastramentos(pagina: number = 0, itens: number = 10) {
    this.checkDiffData();
    if (this.form.valid) {
      const dataInicio = this.form.get('dataInicio').value;
      const dataFim = this.form.get('dataFim').value;

      const filtros = {
        dataInicio: new Date(dataInicio).toISOString().slice(0, 10),
        dataFim: new Date(dataFim).toISOString().slice(0, 10),
        ano: this.form.value.ano,
        comarca: this.form.value.comarca ? this.form.value.comarca : 0,
        lotacao: this.form.value.lotacao ? this.lotacao : 0,
        itens: itens,
        pagina: pagina,
        matricula: this.form.value.servidor ? this.matricula : 0
      };
      this.filtros.emit(filtros);
    }
  }

  periodoCampanha() {
    if (this.form.controls.ano.status == 'VALID') {
      this.form.get('servidor').enable();
      this.relatorioService.periodoCampanho(this.form.value.ano).subscribe((periodoCampanha: any) => {
          this.preencherCamposData(periodoCampanha)
          //this.filtarRecadastramentos();
        },
        (error) => {
          console.error(error);
        }
      );
    }
  }

  private preencherCamposData(data: PeriodoData) {
    if (data?.dataInicio && data?.dataFim) {
      const dataInicio = moment(data.dataInicio).toDate();
      const dataFim = moment(data.dataFim).toDate();

      this.form.patchValue({
        dataInicio,
        dataFim
      });
    }
  }

  changeComarca() {
    this.lotacao = 0;
    this.filteredOptions = [];
    this.form.get("lotacao").enable();
  }

  onInputChange() {
    let value = this.form.value.servidor;
    if (value) {
      this.posCampanhaService.getServidores(value, this.form.value.ano).subscribe(
        (response) => {
          this.optionsServidor = response.content;
          this.filteredOptionsServidor = this.optionsServidor.filter((option) =>
            option.nome.toLowerCase().includes(value.toLowerCase())
          );
        },
        (error) => {
          console.error(error);
        }
      );
    } else {
      this.optionsServidor = [];
      this.filteredOptionsServidor = [];
    }
  }
}
